import { render, staticRenderFns } from "./ExpiringSchedulesDialog.vue?vue&type=template&id=2bc4008a&scoped=true"
import script from "./ExpiringSchedulesDialog.vue?vue&type=script&lang=ts"
export * from "./ExpiringSchedulesDialog.vue?vue&type=script&lang=ts"
import style0 from "./ExpiringSchedulesDialog.vue?vue&type=style&index=0&id=2bc4008a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4008a",
  null
  
)

export default component.exports